import camelcaseKeys from "camelcase-keys";
import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../design";

import axios from "axios";
import { API_HOST } from "../../config";
import { ILoading } from "../../containers/LoadingContainer";
import history from "../../history";
import { IStringTMap } from "../../interfaces";
import { setAuthInfo } from "../../modules/auth";
import Button from "../atoms/Button";
import Image from "../atoms/Image";
import Text from "../atoms/Text";
import Form from "../molecules/Form";
import FormInput from "../molecules/FormInput";

interface IProps {
  loading: ILoading;
}

export interface IAdminUserLoginInfo extends IStringTMap<string> {
  message: string;
  email: string;
  password: string;
}

const Login: React.FC<IProps> = ({ loading }) => {
  const [adminUserInfo, setAdminUserInfo] = useState<IAdminUserLoginInfo>({
    message: "",
    email: "",
    password: ""
  });

  const changeLoginFormEachItem = (item: string, value: string) => {
    // reference: https://reactjs.org/docs/hooks-reference.html#functional-updates
    setAdminUserInfo(prevState => {
      prevState[item] = value;
      return { ...prevState };
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { email, password } = adminUserInfo;
    if (!email) {
      setAdminUserInfo({
        ...adminUserInfo,
        message: "メールアドレスは必須です"
      });
    } else if (!password) {
      setAdminUserInfo({ ...adminUserInfo, message: "パスワードは必須です" });
    } else {
      loading.start();
      const url = `${API_HOST}/api/login`;
      const params = new URLSearchParams();
      params.append("email", email);
      params.append("password", password);
      await axios
        .post(url, params)
        .then(response => {
          const data: any = camelcaseKeys(response.data);
          const res = data.res;
          const token = res.token;
          const admin_id = res.id;
          if (res) {
            setAuthInfo(admin_id, token);
            history.push("/");
          } else {
            setAdminUserInfo({
              ...adminUserInfo,
              message: "ログインに失敗しました"
            });
          }
        })
        .catch(error => {
          history.push("/login");
          console.log("login fail: ", error);
        });
      loading.done();
    }
  };

  return (
    <OutWrapper>
      <Logo src="https://line-photream-assets.s3-ap-northeast-1.amazonaws.com/images/logo.png" />
      <InnerWrapper>
        <Text>{adminUserInfo.message}</Text>
        <Form>
          <>
            <FormInput
              items={[
                {
                  type: "email",
                  key: "email",
                  placeholder: "メールアドレス",
                  value: adminUserInfo.email
                },
                {
                  type: "password",
                  key: "password",
                  placeholder: "パスワード",
                  value: adminUserInfo.password
                }
              ]}
              onChangeEachItem={changeLoginFormEachItem}
            />
            <LoginButton
              title={"ログイン"}
              onClick={(e: React.FormEvent<HTMLFormElement>) => handleSubmit(e)}
            />
          </>
        </Form>
      </InnerWrapper>
    </OutWrapper>
  );
};

export default Login;

const OutWrapper = styled.div`
  padding: 36px 16px;
  max-width: 400px;
  margin: 0 auto;
`;

const Logo = styled(Image)`
  width: 50%;
  display: block;
  margin: 0 auto 32px;
`;
const InnerWrapper = styled.div``;
const LoginButton = styled(Button)`
  background-color: ${colors.lightGreen};
  width: 100%;
  border: none;
  box-shadow: 0 0 2px #ddd;
  color: ${colors.lineWhite};
  padding: 12px;
  font-size: 0.9rem;
  outline: none;
  cursor: pointer;
`;
